/**
 * Feature flags — controls which in-progress features are visible.
 * Flip the value to true locally to develop/test a feature.
 */
const FEATURE_FLAGS = {
  aiContentAttempts: true,
  hideOnboardingAddNewQuestion: true,
  // Per-faculty student DM switches on the batch form (LEARN-1478).
  batchFacultyDmToggle: true,
}

export default FEATURE_FLAGS
